import React, { Component } from 'react'
import HttpServices from '../../utils/Http.services'
import { checkTranslation, translate } from '../../utils/useful'
import IntractionActionsList from '../IntractionActionsList'
import Modal from '../Modal'
import StagesManager from '../StagesManager'
import SendToAction from './SendToAction'
import SendToMain from './SendToMain'
import importedIcons from '../inputs/icons'

export default class TempMessage extends Component {
    state = {
        actions: {
        },
        frameList: [],
    }
    actionClicked = (prop, data, extra) => {
        console.log('prop', prop, data)
        let newProp = JSON.parse(JSON.stringify(prop))
        newProp.key ='useTemplateMessage'
        console.log('propssssa', prop)
        this.props.actionClicked(newProp, data, extra)
    }

    lastPage = () => {
        this.stageManager.lastStage()
    }
    render() {
        return (
            <div>
                {console.log('accctions', this.props)}
                {console.log('accctions2', this.props.actions)}
                {Array.isArray(this.props.page?.actions) && this.props.page.actions.map((item, index) => {
                    // {this.props.actions && Object.values(this.props.actions).map((prop, index) => {
                    if (this.props.actions[item.type]) {
                        let prop = this.props.actions[item.type]
                        console.log('proppropAC', item.templateMessage)
                        return (
                            <>
                                {item.templateMessage.map((element, cIndex) => {
                                    console.log('element.description', element.description)
                                    return (
                                        <div onClick={() => this.actionClicked(prop, element, cIndex)}>
                                            <button>
                                                <p>{element.description}</p>
                                            </button>
                                        </div>
                                    )
                                })}
                            </>
                        )
                    }
                })}
            </div>
        )
    }
}
